module.exports = __webpack_public_path__ + "static/media/peugeot_logo.e643d777.png";